module.exports = __webpack_public_path__ + "img/FUN-Menu-13.79c40efe.png";